import { render, staticRenderFns } from "./CountryCreate.vue?vue&type=template&id=581c068f&scoped=true"
import script from "./CountryCreate.vue?vue&type=script&lang=js"
export * from "./CountryCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581c068f",
  null
  
)

export default component.exports